import React, {useEffect, useState} from "react"
import {Tab, Tabs} from "react-bootstrap"
import {defineMessages, injectIntl} from "react-intl"
import ImageGalleryContentInput from "../../template/sections/content/image-gallery/input.component"
import {Intl} from "../../state/helpers/IntlProps"
import SmsService from "../../state/sms/SmsService"
import {isError} from "../../state/helpers/Error"
import {SMS_MEDIA, SMS_MESSAGING} from "../../state/sms/MessageTypes"
import {TYPE_SMS} from "../../state/conversation/ConversationThreadTypes"

const messages = defineMessages({
    "question_placeholder": {
        id: "question.conversation.modal.textarea_placeholder",
        defaultMessage: "Type your reply here...",
    },
    "invoices": {
        id: "question.conversation.modal.invoice",
        defaultMessage: "invoice",
    },
    "quotes": {
        id: "question.conversation.modal.quote",
        defaultMessage: "quote",
    },
    "orders": {
        id: "question.conversation.modal.order",
        defaultMessage: "order",
    },
    "message": {
        id: "question.conversation.modal.message",
        defaultMessage: "Message",
    },
    "image": {
        id: "question.conversation.modal.image",
        defaultMessage: "Image",
    }
})

type Props = {
    intl: Intl
    threadType: string
    imageIds: string[]
    accountId: string
    content: string
    onImageCallback: (ids: string[]) => object
    onContentCallback: (e: React.ChangeEvent<HTMLTextAreaElement>) => object
}


const SmsInput = (props: Props) => {
    const [activeKey, setActiveKey] = useState("text")
    const [imageQuantity, setImageQuantity] = useState(0)
    const [enabledFeatures, setEnabledFeatures] = useState<string[]>([SMS_MESSAGING])

    useEffect(() => {
        if (props.threadType == TYPE_SMS){
            (async () => {
                const res = await SmsService.get(props.accountId)
                if (!isError(res)) {
                    setEnabledFeatures(res.getEnabledFeatures())
                }
            }
            )()
        }

    }, [])


    const imageQuantityDisplay = imageQuantity > 0 ? `(${imageQuantity})` : ""
    return (
        <Tabs
            activeKey={activeKey}
            onSelect={(k) => k && setActiveKey(k)}
        >
            {enabledFeatures.includes(SMS_MESSAGING) &&
                    <Tab eventKey="text" title={props.intl.formatMessage(messages["message"])}>
                        <textarea
                            name="dialog"
                            value={props.content}
                            onChange={e => props.onContentCallback(e)}
                            id="dialog"
                            rows={5}
                            className="form-control"
                            placeholder={props.intl.formatMessage(messages["question_placeholder"])}
                            disabled={false}
                        />
                    </Tab>
            }

            {enabledFeatures.includes(SMS_MEDIA) &&
                    <Tab eventKey="image"
                        title={`${props.intl.formatMessage(messages["image"])} ${imageQuantityDisplay}`}>
                        <ImageGalleryContentInput
                            imagesIds={props.imageIds}
                            onChange={e => {
                                setImageQuantity(e.imageIds.length)
                                props.onImageCallback(e.imageIds)
                            }}
                            hideLabels={true}
                        />
                    </Tab>
            }
        </Tabs>
    )
}


export default injectIntl(SmsInput)



// WEBPACK FOOTER //
// ./src/question-conversation/components/SmsInput.tsx